import type { CSSProperties, ReactNode } from 'react';

import { AppBanner } from '@playbooks/components/app/app-banner';
import { Route } from '@playbooks/ui/components/route';

import { DocsNav } from 'components/docs/docs-nav';
import { DocsSidebar } from 'components/docs/docs-sidebar';
import { useStorage } from 'contexts';
import { TEMP_AUTH_COOKIE_NAME } from 'utils';

const DocsWrapper = ({ seo = null, children }: { seo?: any; children: ReactNode }) => {
	const storage = useStorage();
	const tempAuth = storage.getCookie(TEMP_AUTH_COOKIE_NAME);
	const headerOffset = tempAuth ? 128 : 64;

	return (
		<Route seo={seo}>
			<div
				style={{ '--docs-header-offset': `${headerOffset}px` } as CSSProperties}
				className='min-h-dvh bg-canvas text-foreground'>
				<header className='sticky top-0 z-40 border-b bg-canvas/95 backdrop-blur supports-backdrop-filter:bg-canvas/80'>
					<AppBanner />
					<DocsNav />
				</header>
				<div className='mx-auto grid w-full max-w-[1600px] md:grid-cols-[15rem_minmax(0,1fr)]'>
					<DocsSidebar topOffset={headerOffset} />
					<main className='min-w-0'>{children}</main>
				</div>
			</div>
		</Route>
	);
};

export { DocsWrapper };
